import { Field, RadioGroup } from 'Components/Core';
import React from 'react';
import { IInterLabSharedComponentProps, InterLabActionOption } from '../types';

const InterLabActionComponent: React.FC<IInterLabSharedComponentProps> = ({
  actionOption: selectedOption,
  onActionOptionChange,
}) => {
  const options: { label: string; value: InterLabActionOption }[] = [
    {
      value: 'transfer',
      label: 'Transfer work order',
    },
    { value: 'copy', label: 'Copy work order for transfer' },
  ];

  return (
    <Field
      input={<RadioGroup />}
      label="Action"
      options={options}
      value={selectedOption}
      onChange={(e: any) => onActionOptionChange?.(e.target.value)}
    />
  );
};

export { InterLabActionComponent };
